import {useState} from "react";
import {SafetyData} from "../../Shared/Model/SafetyData";
import {SafetyState} from "../Model/SafetyState";
import SafetyStateFactory from "../Factory/SafetyStateFactory";
import Homepage from "../../Shared/Page/Homepage";
import Button from "../../Shared/Components/Button";
import SafetyPlay from "./SafetyPlay";
import SafetyWelcome from "./SafetyWelcome";
import {GameFinish} from "../../Shared/Components/GameFinish";
import QuizStateFactory from "../../Quiz/Factory/QuizStateFactory";
import {Diploma} from "../../Shared/Components/Diploma";
import SafetyPageTitle from "./SafetyPageTitle";

export default function SafetyContent(props: { title: string, subtitle: string, data: SafetyData }) {

    const [state, setState] = useState<SafetyState>(SafetyStateFactory.homepage)

    switch (state.screen) {
        case "homepage": return <Homepage
            title={props.title}
            subtitle={props.subtitle}
            buttons={ [
                <Button
                    key="btn-start"
                    color="green"
                    title="Start"
                    onClick={ () => setState(SafetyStateFactory.welcome()) }
                />
            ]}
            onCancel={ () => {} }
        />
        case "welcome": return <SafetyWelcome
            onCancel={() => setState(SafetyStateFactory.homepage())}
            onOpen={() => setState(SafetyStateFactory.play())}
        />
        case "play": return <SafetyPlay
            title={props.title}
            subtitle={props.subtitle}
            tasks={props.data.tasks}
            onCancel={() => setState(SafetyStateFactory.homepage())}
            onFinish={(score) => setState(SafetyStateFactory.finish(props.title, "za ukończenie aplikacji Bezpieczna turystyka z wynikiem", score))}
        />
        case "finish": return <GameFinish
            title={state.title}
            hint={false}
            score={state.score}
            scoreBackground={"images/safety/score.png"}
            pageTitleElement={ <SafetyPageTitle title={props.title} /> }
            onCancel={() => setState(QuizStateFactory.homepage())}
            onEnterName={name => setState(QuizStateFactory.diploma(name, state.title, state.text, state.score))}
        />
        case "diploma": return <Diploma
            title={state.title}
            text={state.text}
            name={state.name}
            score={state.score}
            scoreBackground={"images/safety/score.png"}
            pageTitleElement={ <SafetyPageTitle title={props.title} /> }
            onCancel={() => setState(QuizStateFactory.homepage())}
        />
    }
}